import * as toastr from "toastr";
import { FeatureType, ICAMSKey } from '../Models/UtilityModels';
import { ISearchConfig, ISearchTypeConfig, SearchInitialConfig } from './SearchConfig';
import { Any } from "io-ts";
import { Utilities } from "../Utility/Utilities";

import * as events from '../Bus/Bus';

export class Search {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private searchType: string = 'MaintCode';
    private configModel: ISearchConfig;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
        this.initMisc();
        this.initialised = true;
    }

    private initEvents = (): void => {
        const self = this;

        //click handlers for buttons
        $('#searchInput_SearchCloseBtn').on('click', function () {
            events.bus.publish(events.eventResetRightPanels());
        });

        $('#searchInput_SearchNowBtn').on('click', function () {
            if (self.checkSearchTextLength('#searchInput_SearchInput', 3)) { self.searchBasic(); }
        });

        $('#searchInput_SearchNowAdvBtn').on('click', function () {
            if (self.checkSearchTextLength('#searchInput_SearchAdvInput', 1)) { self.searchAdvanced(); }
        });

        //allow press of enter key when focus is in search textboxes to trigger search
        $('#searchInput_SearchAdvInput').keyup(function (e) {
            if (e.which == 13)  // the enter key code
            {
                $('#searchInput_SearchNowAdvBtn').trigger('click');;
                return false;
            }
        });

        $('#searchInput_SearchInput').keyup(function (e) {
            if (e.which == 13)  // the enter key code
            {
                $('#searchInput_SearchNowBtn').trigger('click');;
                return false;
            }
        });

        $('[data-searchtype]').on("click", function () {
            self.searchType = $(this).data("searchtype");
        });
    }

    private initMisc = (): void => {
        // Get config data from the Razor page
        this.configModel = this.parseConfig($("#searchSettingsDataContainer").data("settings"));
    }

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // SEARCH
    private searchBasic = (): void => {
        const self = this;
        const searchText = $('#searchInput_SearchInput').val().toString().trim();

        if (searchText != null) {
            try {
                let query = {
                    data: {
                        MaintCodePartial: null, InfraCodePartial: null, RouteCodePartial: null, LandCodePartial: null, TaskID: null, adminAreas: [], postcodes: [], geonames: []
                    }
                };

                if (!/\d/.test(searchText)) {
                    //If the search term has no numeric characters then it's a placename so do location search
                    if (self.configModel.AdminAreaDescr.IncludeInBasicSearch == true) {
                        query.data.adminAreas.push(searchText); //Could also be admin area so check that as well
                    }
                    if (self.configModel.Settlement.IncludeInBasicSearch == true) {
                        query.data.geonames.push(searchText); //Could also be admin area so check that as well
                    }
                    self.loadResultsIntoPanel(query) //Append the new cards
                    return;
                }

                if (/^[a-zA-Z0-9]{1,5}\//.test(searchText)) {
                    //three characters then a slash, could be route or infra, just pass to controller to search our database
                    if (self.configModel.RouteCode.IncludeInBasicSearch == true) {
                        query.data.RouteCodePartial = searchText;
                    }
                    if (self.configModel.InfraCode.IncludeInBasicSearch == true) {
                        query.data.InfraCodePartial = searchText;
                    }
                    self.loadResultsIntoPanel(query) //Append the new cards
                    return;
                }

                if (/^\d+$/.test(searchText)) {
                    //numbers only, could be land or maint or partial route/infra, just pass to controller to search our database
                    if (self.configModel.LandCode.IncludeInBasicSearch == true) {
                        query.data.LandCodePartial = searchText;
                    }
                    if (self.configModel.RouteCode.IncludeInBasicSearch == true) {
                        query.data.RouteCodePartial = searchText;
                    }
                    if (self.configModel.InfraCode.IncludeInBasicSearch == true) {
                        query.data.InfraCodePartial = searchText;
                    }
                    if (self.configModel.TaskID.IncludeInBasicSearch == true) {
                        query.data.TaskID = searchText;
                    }
                    self.loadResultsIntoPanel(query) //Append the new cards
                    return;
                }

                // Always do these searches, we don't reliably know if this is/isn't one of these
                if (self.configModel.MaintCode.IncludeInBasicSearch == true) {
                    query.data.MaintCodePartial = searchText;
                }

                // Search for GridRef
                if (self.configModel.GridRef.IncludeInBasicSearch == true) {
                    if (this.validateGridRef(searchText) == true) return;
                }

                // Search for a postcode, but only take the first bit - e.g. LD3 (this works is the user outs in LD3 0AH, LD3, etc)
                //var pc = searchText.split(' ')[0];
                //var pc = searchText.replace(' ','');
                var pc = searchText;
                if (self.validatePostcode(pc)) {
                    //its a valid postcode, so try a postcode search
                    if (self.configModel.Postcode.IncludeInBasicSearch) {
                        self.postcodeSearch(pc, query); //use geonames API
                    }
                    return;
                }

                toastr.error('Could not determine search type.');
            }
            catch (e) {
                console.log(e);
                toastr.error('Error getting search results');
            }
        }
    }

    private searchAdvanced = (): void => {
        const self = this;
        const searchText = $('#searchInput_SearchAdvInput').val().toString().trim();

        if (searchText != null) {
            try {
                let query = {
                    data: {
                        MaintCodePartial: null, InfraCodePartial: null, RouteCodePartial: null, LandCodePartial: null, TaskID: null, adminAreas: [], postcodes: [], geonames: []
                    }
                };

                switch (self.searchType) {
                    case 'RouteCode': {
                        query.data.RouteCodePartial = searchText; //just pass to controller to search our database
                        self.loadResultsIntoPanel(query) // Append the new cards
                        break;
                    }
                    case 'InfraCode': {
                        query.data.InfraCodePartial = searchText; //just pass to controller to search our database
                        self.loadResultsIntoPanel(query) // Append the new cards
                        break;
                    }
                    case 'MaintCode': {
                        query.data.MaintCodePartial = searchText; //just pass to controller to search our database
                        self.loadResultsIntoPanel(query) // Append the new cards
                        break;
                    }
                    case 'LandCode': {
                        query.data.LandCodePartial = searchText; //just pass to controller to search our database
                        self.loadResultsIntoPanel(query) // Append the new cards
                        break;
                    }
                    case 'TaskID': {
                        query.data.TaskID = searchText; //just pass to controller to search our database
                        self.loadResultsIntoPanel(query) // Append the new cards
                        break;
                    }
                    case 'AdminAreaDescr': {
                        query.data.adminAreas.push(searchText); //just pass to controller to search our database
                        self.loadResultsIntoPanel(query); // Append the new cards
                        break;
                    }
                    case 'Postcode': {
                        this.postcodeSearch(searchText, query); //use geonames API
                        break;
                    }
                    case 'Settlement': {
                        query.data.geonames.push(searchText); //just pass to controller to search our database
                        self.loadResultsIntoPanel(query); // Append the new cards
                        //this.settlementSearch(searchText, query); //use geonames API
                        break;
                    }
                    case 'GridRef': {
                        this.validateGridRef(searchText); //not really a search, we just parse the coordinates & move the map
                        break;
                    }
                }
            }
            catch (e) {
                console.log(e);
                toastr.error('Error getting search results');
            }
        }
    }

    public bindEventsOnPageLoad = (): void => {
        // If the row is clicked
        $('[name="searchResultRow"]').on('click', function () {
            const data: ICAMSKey = $(this).find('[data-showonmap]').data("showonmap");

            if (data.featureType == FeatureType.LatLon) {
                events.bus.publish(events.eventZoomToLatLon([data, true, true]));
            }
            else if (data.wkt != null) {
                events.bus.publish(events.eventZoomToWKTandHighlight([[data.wkt], true, true, data.featureType]));
            }

        });

        $('[data-editfeature]').on('click', function () {
            const data: ICAMSKey = $(this).data("editfeature");

            if (data.featureType == FeatureType.Maint)  events.bus.publish(events.eventOpenMaintEditPanel(data));
            if (data.featureType == FeatureType.Infra)  events.bus.publish(events.eventOpenInfraEditPanel([data,null]));
            if (data.featureType == FeatureType.Route)  events.bus.publish(events.eventOpenRouteEditPanel(data));
            if (data.featureType == FeatureType.Path)  events.bus.publish(events.eventOpenPathEditPanel(data));
            if (data.featureType == FeatureType.Land)  events.bus.publish(events.eventOpenLandEditPanel(data));
            if (data.featureType == FeatureType.TRO)  events.bus.publish(events.eventOpenTROGeomEditPanel(data));
        });

        if ($('[data-showonmap]').length == 1) {
            //only one result, so let's click it automatically
            $('[data-showonmap]')[0].click();
        }

        //$('#searchPanel').css("bottom", "0px");
    }

    private loadResultsIntoPanel = (query: any): void => {
        const self = this;
        $('#searchResultsContainer').empty();
        $('#searchResultsContainer').removeClass('invisible');
        Utilities.BlockUI($('#searchPanel'));
        $('#searchResultsContainer').load(window.G_SITEFOLDERNAME +'/Search/GetSearchResultsList', query, function () {
            Utilities.UnBlockUI($('#searchPanel'));
            self.bindEventsOnPageLoad();
        });
    }

    private settlementSearch = (searchText: string, query: any): void => {
        const self = this;
        let url = encodeURI('/api/GeoNames/Location?name_startsWith=' + searchText);
        let callback = function (response) {
            Utilities.UnBlockUI($('#search_loader'));
            if (response.geonames && response.geonames.length > 0) {
                for (var i = 0; i < response.geonames.length; i++) {
                    //push to controller to return result markup
                    query.data.geonames.push({ 'Name': response.geonames[i].name, 'AdminName': response.geonames[i].adminName1, 'Lat': response.geonames[i].lat, 'Lon': response.geonames[i].lng });
                }
                self.loadResultsIntoPanel(query) // Append the new cards
            }
        };

        Utilities.BlockUI($('#search_loader'));
        $.get(url, null, callback, 'json').fail(function (err) { Utilities.UnBlockUI($('#search_loader')); console.log(err); });
    }

    private postcodeSearch = (searchText: string, query: any): void => {
        const self = this;
        let postcode = searchText;

        if (postcode.length >= 6 && postcode.charAt(postcode.length - 4) != " ") {
            //if the postcode is 6 or more chars long then we must insert a space immediately before the last 3 digits [if there isn't one already]
            //the geonames service seems to do an exact match on postcode, spaces included
            postcode = postcode.replace(/([0-9][\w]{2})$/g, " $1");
        }

        if (!self.validatePostcode(postcode)) {
            toastr.error('Please enter a valid postcode or the start of a postcode');
            return;
        }

        query.data.postcodes.push(searchText); //just pass to controller to search our database
        self.loadResultsIntoPanel(query) // Append the new cards

        //let url = encodeURI('/api/GeoNames/PostCode?postalcode=' + postcode);
        //let callback = function (response) {
        //    Utilities.UnBlockUI($('#search_loader'));

        //    if (response.postalCodes && response.postalCodes.length > 0) {
        //        for (var i = 0; i < response.postalCodes.length; i++) {
        //            //push to controller to return result markup
        //            query.data.postcodes.push({ 'PostalCode': response.postalCodes[i].postalCode, 'PlaceName': response.postalCodes[i].placeName, 'Lat': response.postalCodes[i].lat, 'Lon': response.postalCodes[i].lng });
        //        }
        //        self.loadResultsIntoPanel(query) // Append the new cards
        //    }
        //};

        //Utilities.BlockUI($('#search_loader'));
        //$.get(url, null, callback, 'json').fail(function (err) { Utilities.UnBlockUI($('#search_loader')); console.log(err); toastr.error("Failed to get any postcodes.");});
    }

    private validatePostcode = (postcode: string): boolean => {
        if (postcode.length < 2) //too short
            return false;
        if (postcode.length > 8) //too long
            return false;
        if (postcode.length == 2) {
            return /^[A-Za-z]\d/.test(postcode); //test if valid 2 char 1st section eg A1
        }
        if (postcode.length == 3) {
            return (/^[A-Za-z]{2}\d{1}/.test(postcode) || /^[A-Za-z]{1}\d{2}/.test(postcode) || /^[A-Za-z]{1}\d{1}[A-Za-z]{1}/.test(postcode)); //test if valid 3 char 1st section eg AA1, A11, A1A
        }
        if (postcode.length == 4) {
            return (/^[A-Za-z]{2}\d{2}/.test(postcode) || /^[A-Za-z]{2}\d{1}[A-Za-z]{1}/.test(postcode)); //test if valid 4 char 1st section eg AA11, AA1A
        }

        // If the string has a space, test part 1 and 2. If they are both ok, then return true
        if (postcode.indexOf(' ') != -1) {
            var pc = postcode.split(' '); 
            var part1 = this.validatePostcode(pc[0]);
            var last3 = (/^\d{1}[A-Za-z]{2}/.test(pc[1]));
            if (part1 == true && last3 == true) return true;
        }

        // Finally if it's longer than 4 chars and no space you have to assume a full postcaode eg LD37BX
        if (postcode.length > 4) {
            // test the first 3 or 4 chars, if either are ok then this might be a postcode
            var char3 = (/^[A-Za-z]{2}\d{1}/.test(postcode.substr(0, 3)) || /^[A-Za-z]{1}\d{2}/.test(postcode.substr(0, 3)) || /^[A-Za-z]{1}\d{1}[A-Za-z]{1}/.test(postcode.substr(0, 3)));
            var char4 = (/^[A-Za-z]{2}\d{2}/.test(postcode.substr(0, 4)) || /^[A-Za-z]{2}\d{1}[A-Za-z]{1}/.test(postcode.substr(0, 4)));
            var last3 = (/^\d{1}[A-Za-z]{2}/.test(postcode.substr(postcode.length - 3, 3)));
            if ((char3 == true || char4 == true) && last3==true) return true;

            //if (postcode.indexOf(' ') <= 0) return false; // Its got to have a space
            //var pc = postcode.split(' ');
            //return (this.validatePostcode(pc[0]) && /^\d{1}[A-Za-z]{2}/.test(pc[1])); //pass 1st part back into this function and check 2nd part like 1AA
        }
    }

    private validateGridRef = (gridref: string): Boolean => {
        let easting: any = null;
        let northing: any = null;
        let coords: any = null;
        let isValid: boolean = true;

        // use first two chars as sheet
        let sheet: string = gridref.substring(0, 2);
       
        if (/[A-Za-z]{2}/.test(sheet)) {
            sheet = sheet.toUpperCase();
            //we have a sheet prefix, so the x/y coords must have the same number of digits
            //remove all spaces
            coords = gridref.replace(/\s/g, '').substring(2);

            if (!isNaN(coords) && coords.length >= 4 && (coords.length % 2 == 0)) {
                //we have an even number
                let coordLen: number = coords.length / 2;
                easting = coords.substring(0, coordLen);
                northing = coords.substring(coordLen);

                //test that coords are both numbers
                if (isNaN(easting) || isNaN(northing)) {
                    //not both numbers
                    isValid = false;
                }

                //all ok we should have a sheet number and two coords
            }
            else {
                //not an even number
                isValid = false;
            }
        }
        else {
            //no sheet prefix
            isValid = false;
        }

        if (isValid) {
            //pad to five char with zeros on right
            for (var i = 0; i < (5 - easting.length); i++) {
                easting = easting + '0';
                northing = northing + '0';
            }
            events.bus.publish(events.eventZoomToGridRef([{ gridRef: sheet + ' ' + easting + ' ' + northing, zoom: this.configModel.GridRef.MapZoomForResult }, true, true]));
            return true;
        }
        else {
            //toastr.error("Please enter a valid grid reference e.g SO 77665 46901");
            return false;
        }
    }

    private checkSearchTextLength = (inputId: string, maxLen: number): boolean => {
        const searchText = $(inputId).val().toString();

        if (searchText.length > maxLen-1) {
            return true;
        }
        else {
            toastr.error("Please enter at least " + maxLen +" characters");
            return false;
        }
    }

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // MISC
    private parseConfig = (data: ISearchTypeConfig[]): ISearchConfig => {
        //Set a default config object in case any of the passed-in values are null
        let configResult: ISearchConfig = SearchInitialConfig.defaultConfig;

        //loop over the data object from the view and assign any values
        for (var i = 0; i < data.length; i++) {
            switch (data[i].SearchTypeName) {

                case 'RouteCode': {
                    configResult.RouteCode = data[i];
                    break;
                }
                case 'InfraCode': {
                    configResult.InfraCode = data[i];
                    break;
                }
                case 'MaintCode': {
                    configResult.MaintCode = data[i];
                    break;
                }
                case 'LandCode': {
                    configResult.LandCode = data[i];
                    break;
                }
                case 'TaskID': {
                    configResult.TaskID = data[i];
                    break;
                }
                case 'AdminAreaDescr': {
                    configResult.AdminAreaDescr = data[i];
                    break;
                }
                case 'Postcode': {
                    configResult.Postcode = data[i];
                    break;
                }
                case 'Settlement': {
                    configResult.Settlement = data[i];
                    break;
                }
                case 'GridRef': {
                    configResult.GridRef = data[i];
                    break;
                }
            }
        }

        return configResult;
    }
    // ----------------------------------------------------------- //

}
